function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m 0.44624,20.09 c 0,-10.778 8.7498,-19.527 19.527,-19.527 10.815,0 19.527,8.7498 19.527,19.527 0,10.815 -8.7123,19.527 -19.527,19.527 -10.778,0 -19.527,-8.7123 -19.527,-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});

var SvgSidepanelCandidate2 = function SvgSidepanelCandidate2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    style: {
      display: "inline"
    }
  }, _ref3), React.createElement("g", {
    style: {
      display: "inline"
    }
  }, React.createElement("path", {
    d: "m 31.868579,15.643 0.763,0.154 c 2.206,0.933 3.754,3.117 3.754,5.663 v 5.154 l -2.687,0.976 c -1.816,0.431 -3.694,0.656 -5.599,0.656 -1.906,0 -3.784,-0.225 -5.6,-0.656 l -1.717,-0.624 0.189,0.013 c 3.344,-0.25 6.555,-1.936 8.642,-4.888 0.928,-1.311 1.545,-2.749 1.868,-4.226 l 0.043,-1.914 0.251,-0.169 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    d: "m 29.59,8.431001 1.311,0.284 c 1.58,0.716 2.689,2.393 2.689,4.347 0,1.302999 -0.493,2.481999 -1.289,3.335999 l -0.046,0.033 0.054,-2.645 c -0.213,-1.331999 -0.663,-2.619999 -1.338,-3.785999 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    d: "m 8.9511896,15.64299 -0.762389,0.153932 c -2.206143,0.933089 -3.75408,3.117571 -3.754053,5.663622 l -3.4e-5,5.153106 2.686494,0.976238 c 1.816359,0.431676 3.6941454,0.655986 5.5996184,0.655953 1.90562,-1.5e-5 3.783481,-0.22424 5.599614,-0.656006 l 1.716734,-0.623819 -0.188527,0.01327 C 16.50457,26.729488 13.293577,25.043582 11.206474,22.091578 10.278916,20.779638 9.6610946,19.341664 9.3381036,17.864972 l -0.04251,-1.914143 -0.250813,-0.169058 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    d: "M 12.59,8.431001 10.95119,8.714646 C 8.97596,9.430858 7.59,11.107581 7.59,13.061751 c 0,1.302839 0.61596,2.482299 1.61191,3.335999 L 9.25937,16.431 9.1908,13.78596 c 0.26674,-1.331999 0.82979,-2.620359 1.67337,-3.786189 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    className: "icon-secondary"
  }), React.createElement("g", {
    className: "icon-tertiary"
  }, React.createElement("path", {
    d: "m 31.868579,15.643002 0.763,0.154 c 2.206,0.933 3.754,3.117 3.754,5.663 v 5.154 l -2.687,0.976 c -1.816,0.431 -3.694,0.656 -5.599,0.656 -1.906,0 -3.784,-0.225 -5.6,-0.656 l -1.717,-0.624 0.189,0.013 c 3.344,-0.25 6.555,-1.936 8.642,-4.888 0.928,-1.311 1.545,-2.749 1.868,-4.226 l 0.043,-1.914 0.251,-0.169 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  }), React.createElement("path", {
    d: "m 29.59,8.431003 1.311,0.284 c 1.58,0.716 2.689,2.393 2.689,4.347 0,1.302999 -0.493,2.481999 -1.289,3.335999 l -0.046,0.033 0.054,-2.645 c -0.213,-1.331999 -0.663,-2.619999 -1.338,-3.785999 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  }), React.createElement("path", {
    d: "m 8.95119,15.642992 -0.762389,0.153932 c -2.206143,0.933089 -3.75408,3.117571 -3.754053,5.663622 l -3.4e-5,5.153106 2.686494,0.976238 c 1.816359,0.431676 3.694145,0.655986 5.599618,0.655953 1.90562,-1.5e-5 3.783481,-0.22424 5.599614,-0.656006 l 1.716734,-0.623819 -0.188527,0.01327 C 16.50457,26.72949 13.293577,25.043584 11.206474,22.09158 10.278916,20.77964 9.661095,19.341666 9.338104,17.864974 L 9.295594,15.950831 9.044781,15.781773 Z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  }), React.createElement("path", {
    d: "M 12.59,8.431003 10.95119,8.714648 C 8.97596,9.43086 7.59,11.107583 7.59,13.061753 c 0,1.302839 0.61596,2.482299 1.61191,3.335999 l 0.05746,0.03325 -0.06857,-2.64504 c 0.26674,-1.331999 0.82979,-2.620359 1.67337,-3.786189 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  }))), React.createElement("g", {
    style: {
      display: "inline"
    }
  }, React.createElement("path", {
    d: "m 16.496,19.431 0.102,0.154 c 1.021,1.045 2.433,1.692 3.992,1.692 1.559,0 2.971,-0.647 3.993,-1.692 l 0.101,-0.154 0.829,0.171 c 2.396,1.037 4.077,3.463 4.077,6.292 v 5.724 l -2.918,1.084 c -1.973,0.48 -4.012,0.729 -6.082,0.729 -2.07,0 -4.109,-0.249 -6.082,-0.729 L 11.59,31.618 v -5.724 c 0,-2.829 1.681,-5.255 4.078,-6.292 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    d: "m 14.59,15.492244 c 0,-3.280351 2.686,-5.9387535 6,-5.9387535 3.314,0 6,2.6584025 6,5.9387535 0,3.280352 -2.686,5.938755 -6,5.938755 -3.314,0 -6,-2.658403 -6,-5.938755 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    className: "icon-secondary"
  }), React.createElement("g", {
    className: "icon-tertiary"
  }, React.createElement("path", {
    d: "m 16.158651,19.527388 c 1.20041,1.093999 3.098949,1.7287 4.431349,1.749614 1.559,0 3.509208,-0.642112 4.531208,-1.687112 v 0 L 25.513,19.602 c 2.396,1.037 4.077,3.463 4.077,6.292 v 5.724 l -2.918,1.084 c -1.973,0.48 -4.012,0.729 -6.082,0.729 -2.07,0 -4.109,-0.249 -6.082,-0.729 L 11.59,31.618 v -5.724 c 0,-2.829 2.114735,-5.303193 4.078,-6.292 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  }), React.createElement("path", {
    d: "m 14.59,15.492246 c 0,-3.280351 2.686,-5.938753 6,-5.938753 3.314,0 6,2.658402 6,5.938753 0,3.280352 -2.686,5.938755 -6,5.938755 -3.314,0 -6,-2.658403 -6,-5.938755 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  }))), React.createElement("g", {
    style: {
      display: "inline"
    }
  }, React.createElement("path", {
    d: "m 19.106771,6.7727724 c -2.25,0.387 -4.353,1.631 -5.775,3.6430016 -1.423,2.012 -1.895,4.408999 -1.509,6.659999 0.387,2.25 1.631,4.353 3.643,5.775 4.024,2.845 9.591,1.889 12.436,-2.134 2.844,-4.023 1.889,-9.590999 -2.135,-12.4350006 -2.011,-1.423 -4.409,-1.895 -6.66,-1.509 z m -0.459,-2.676 c 2.935,-0.504 6.063,0.112 8.687,1.967 5.248,3.711 6.494,10.9730006 2.784,16.2210006 -2.783,3.936 -7.563,5.621 -11.994,4.652 l -0.955,-0.422 -8.1700002,11.556 c -1.075,1.521 -3.179,1.882 -4.7,0.807 -1.52,-1.075 -1.881,-3.18 -0.806,-4.7 l 8.1380002,-11.512 -0.904,-0.959 c -0.7970002,-1.284 -1.3290002,-2.704 -1.5810002,-4.172 -0.504,-2.935 0.112,-6.062999 1.9670002,-8.6870006 1.856,-2.624 4.599,-4.247 7.534,-4.751 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#ecaec6",
    fillRule: "evenodd",
    style: {
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none",
      stroke: "none"
    },
    className: "icon-primary"
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 9.11111,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#ecaec6",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "m 18.982,6.835999 c -2.25,0.387 -4.353,1.631 -5.775,3.643002 -1.423,2.012 -1.895,4.408999 -1.509,6.659999 0.387,2.25 1.631,4.353 3.643,5.775 4.024,2.845 9.591,1.889 12.436,-2.134 2.844,-4.023 1.889,-9.590999 -2.135,-12.435001 -2.011,-1.423 -4.409,-1.895 -6.66,-1.509 z m -0.459,-2.676 c 2.935,-0.504 6.063,0.112 8.687,1.967 C 32.458,9.837999 33.704,17.1 29.994,22.348 27.211,26.284 22.431,27.969 18,27 l -0.955,-0.422 -8.17,11.556 c -1.075,1.521 -3.179,1.882 -4.7,0.807 -1.52,-1.075 -1.881,-3.18 -0.806,-4.7 L 11.507,22.729 10.603,21.77 C 9.806,20.486 9.274,19.066 9.022,17.598 8.518,14.663 9.134,11.535001 10.989,8.910999 c 1.856,-2.624 4.599,-4.247 7.534,-4.751 z"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSidepanelCandidate2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sidepanel-candidate2.c82704cc.svg";
export { ForwardRef as ReactComponent };